// Uchrashuv — preview thumbnail. The full design at
// /templates/uchrashuv.html is a romantic envelope-style date-ask
// (paper + wine + mauve + rose). The 5:7 thumbnail leans into the
// "open me" envelope feel: wax seal, a script "Aziza" recipient,
// and a wine-lettered "Och" pill below.

import type { LayoutCtx } from "./_shared";

export function UchrashuvPreviewLayout({ names, date, venue, ink, bg, font }: LayoutCtx) {
  const wine = "#6B1F2A";
  const mauve = "#6B4C8A";
  const gold = "#B89968";
  // names format: "Bobur & Aziza" — left = sender, right = recipient
  const [sender, recipient] = names.split(/\s*&\s*/);
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: bg,
        color: ink,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "center",
        padding: "12% 9%",
      }}
    >
      {/* Wine corner frame */}
      <div aria-hidden style={{ position: "absolute", inset: "5%", border: `1px solid ${wine}33` }} />

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 600,
            letterSpacing: "0.5em",
            textTransform: "uppercase",
            color: wine,
          }}
        >
          Taklifnoma
        </div>
        <div aria-hidden style={{ width: 1, height: 22, background: `linear-gradient(to bottom, ${wine}, transparent)` }} />
      </div>

      {/* Wax seal + recipient script */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
        <div
          aria-hidden
          style={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            background: `radial-gradient(circle at 30% 28%, #8B2A38 0%, ${wine} 45%, #4F1620 100%)`,
            color: bg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 8px -4px rgba(107,31,42,0.5), inset 0 0 0 1.4px rgba(245,239,230,0.25)",
            fontFamily: "'Pinyon Script', cursive",
            fontSize: 26,
            lineHeight: 1,
          }}
        >
          {(sender ?? "B").charAt(0)}
        </div>
        <div
          style={{
            fontFamily: "'Caveat', cursive",
            fontWeight: 500,
            fontSize: 13,
            color: ink,
            lineHeight: 1.25,
            maxWidth: "85%",
          }}
        >
          <span style={{ color: wine }}>{sender ?? "Bobur"}</span> sendan bir narsa…
        </div>
        <div
          style={{
            fontFamily: "'Pinyon Script', cursive",
            fontSize: 36,
            color: wine,
            lineHeight: 1,
            marginTop: 2,
          }}
        >
          {recipient ?? "Aziza"}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
        {/* Pill */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "7px 18px",
            borderRadius: 999,
            background: wine,
            color: bg,
            fontFamily: "var(--font-ui)",
            fontSize: 7.5,
            fontWeight: 700,
            letterSpacing: "0.4em",
            textTransform: "uppercase",
            boxShadow: `0 6px 14px -8px ${wine}`,
          }}
        >
          <span>Och</span>
          <span aria-hidden>→</span>
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 600,
            letterSpacing: "0.34em",
            color: ink,
            opacity: 0.7,
            textTransform: "uppercase",
          }}
        >
          {date.replace(/\./g, " · ")}
        </div>
        <div style={{ fontFamily: font, fontStyle: "italic", fontSize: 10, color: mauve, opacity: 0.85, marginTop: 1 }}>
          {venue}
        </div>
      </div>
    </div>
  );
}
